module.exports = __webpack_public_path__ + "img/lock.e2e97824.svg";